export function getKontrola(kontrola) {
    return { type: 'GET_KONTROLA', kontrola };
}
